export default __webpack_public_path__ + "static/media/img3.ac4d5ab1.jpeg";